import { Component, OnInit ,Input } from '@angular/core';
import {ViewCell} from '../../ng2-smart-table/components/cell/cell-view-mode/view-cell';
@Component({
  selector: 'app-table-value-highlight',
  template: `<mark style="background-color: #6F6F8D;border-radius: 10px;color:white; padding: 8%;  border-radius: 16px;
  padding-left: 16px;
  padding-right: 16px;">{{renderValue}}</mark>`,
  styleUrls: ['./table-value-highlight.component.scss']
})
export class TableValueHighlightComponent implements ViewCell, OnInit {

  constructor() { }
  @Input() value: any = [];
  @Input() rowData: any;
  renderValue: string;

  // console.log()

  ngOnInit() {
    this.renderValue = this.value.toString().toUpperCase();
    // console.log(this.rowData,this.value,"-------------Table value view")
  }

}
